export const SHOPPABLE_RETURN_URL = 'shoppableReturnUrl'
